import { Component, OnInit, ViewChild } from '@angular/core';
import { IFile } from 'src/app/interfaces/io/file.interface';
import { VfmService } from 'src/app/services/io/vfm.service';
import { ContextMenuService } from 'src/app/services/ux/context-menu.service';
import { ThemeService } from 'src/app/services/ux/theme.service';
import { IContextMenuAction } from '../../ux/context-menu/context-menu-action.interface';
import { ContextMenuComponent } from '../../ux/context-menu/context-menu.component';
import { LauncherComponent } from '../launcher/launcher.component';

@Component({
  selector: 'app-desktop-layer',
  templateUrl: './desktop-layer.component.html',
  styleUrls: ['./desktop-layer.component.scss']
})
export class DesktopLayerComponent implements OnInit {
  @ViewChild("desktopMenu") desktopMenu: ContextMenuComponent;
  @ViewChild("iconsMenu") iconsMenu: ContextMenuComponent;

  files: IFile[] = [];

  private selected: IFile = null;
  private selectedDate = new Date();

  fileMenuActions: IContextMenuAction[] = [];
  desktopMenuActions: IContextMenuAction[] = [];

  constructor(
    private contextMenuSv: ContextMenuService,
    private theme: ThemeService,
    private vfmSv: VfmService) {
  }

  async ngOnInit() {
    await this.load();
  }

  get iconSize() {
    return { w: 120, h: 120 };
  }

  get cwd() {
    return "C:/desktop";
  }

  async load() {
    this.files = await this.vfmSv.list(this.cwd);

    this.desktopMenuActions = [
      { name: "Toggle dark mode", action: () => { this.theme.toggleDarkMode(); } }
    ];
  }

  isSelected(file: IFile) {
    return this.selected && this.selected.path === file.path;
  }

  manageDesktopClick(ev: MouseEvent) {
    this.selected = null;
    this.selectedDate = null;
    this.closeContextMenu();
  }

  manageClick(ev: MouseEvent, launcher: LauncherComponent, file: IFile) {
    ev.preventDefault();
    ev.stopPropagation();

    this.closeContextMenu();

    const d = new Date();
    if (this.isSelected(file)) {
      if (ev.button === 0) {
        if (this.selectedDate && (d.getTime() - this.selectedDate.getTime()) <= 400) {
          launcher.launch(file, this.cwd);
          this.selectedDate = d;
          return;
        }
      }
    }

    this.selected = file;
    this.selectedDate = d;
  }

  showFileContextMenu(ev: MouseEvent, launcher: LauncherComponent, file: IFile) {
    ev.preventDefault();
    ev.stopPropagation();
    this.closeContextMenu();

    this.fileMenuActions = [
      { name: "Open", action: () => { launcher.launch(file, this.cwd); } }
    ];

    this.contextMenuSv.show(this.iconsMenu, ev.pageX, ev.pageY);
  }

  showDesktopContextMenu(ev: any) {
    ev.preventDefault();
    ev.stopPropagation();
    this.closeContextMenu();
    this.contextMenuSv.show(this.desktopMenu, ev.pageX, ev.pageY);
  }

  closeContextMenu() {
    this.contextMenuSv.close();
  }
}
